import GenericNewCategoryPage from './GenericNewCategoryPage';

function Changemakers() {
  return <GenericNewCategoryPage categoryId={17} categoryKey="changemakers" />;
}

export default Changemakers;
